<template>
  <div>
    <form class="form-horizontal">
      <div class="box-body">
        <div class="form-group">
          <label class="col-sm-3 col-md-3 col-lg-3 control-label">{{
            $t("apartment.apartment_code")
          }}</label>
          <div class="col-sm-4 col-md-4 col-lg-4">
            <input
              disabled
              v-model="apartment.apartment_code"
              type="text"
              class="form-control"
              :placeholder="$t('apartment.apartment_code')"
            />
          </div>
        </div>
        <div class="form-group">
          <label class="col-sm-3 col-md-3 col-lg-3 control-label">{{
            $t("apartment.size")
          }}</label>
          <div class="col-sm-4 col-md-4 col-lg-4">
            <input
              disabled
              v-model="apartment.size"
              type="text"
              class="form-control"
              :placeholder="$t('apartment.size')"
            />
          </div>
        </div>

        <div class="form-group" v-show="false">
          <label class="col-sm-3 col-md-3 col-lg-3 control-label">{{
            $t("apartment.rental_status")
          }}</label>
          <div class="col-sm-4 col-md-4 col-lg-4">
            <b-form-select
              :options="apartmentStatusOptions"
              required
              v-model="apartment.status"
              class="form-control"
            />
            <small
              :style="{
                visibility: apartment.status !== 1 ? 'visible' : 'hidden'
              }"
              class="form-text text-muted required"
            >
              <font color="red">*</font> {{ $t("apartment.rental_note") }}
            </small>
          </div>
        </div>

        <div class="form-group">
          <label class="col-sm-3 col-md-3 col-lg-3 control-label">{{
            $t("apartment.bedroom_count")
          }}</label>
          <div class="col-sm-1 col-md-1 col-lg-1">
            <b-form-input
              type="number"
              required
              v-model="apartment.bedroom_count"
              :placeholder="$t('apartment.bedroom_count')"
            />
          </div>
        </div>

        <div class="form-group" v-show="false">
          <label class="col-sm-3 col-md-3 col-lg-3 control-label">{{
            $t("apartment.bathroom_count")
          }}</label>
          <div class="col-sm-1 col-md-1 col-lg-1">
            <b-form-input
              type="number"
              required
              v-model="apartment.bathroom_count"
              :placeholder="$t('apartment.bathroom_count')"
            />
          </div>
        </div>

        <div class="form-group" v-show="false">
          <label class="col-sm-3 col-md-3 col-lg-3 control-label">{{
            $t("apartment.room_count")
          }}</label>
          <div class="col-sm-1 col-md-1 col-lg-1">
            <b-form-input
              type="number"
              required
              v-model="apartment.room_count"
              :placeholder="$t('apartment.room_count')"
            />
          </div>
        </div>

        <!-- BEGIN - Add new field -->
        <div class="form-group">
          <label class="col-sm-3 col-md-3 col-lg-3 control-label">{{
            $t("apartment.block")
          }}</label>
          <div class="col-sm-1 col-md-1 col-lg-1">
            <b-form-input
              type="text"
              :disabled="true"
              v-model="apartment.block"
              :placeholder="$t('apartment.block')"
            />
          </div>
        </div>

        <div class="form-group">
          <label class="col-sm-3 col-md-3 col-lg-3 control-label">{{
            $t("apartment.floor")
          }}</label>
          <div class="col-sm-1 col-md-1 col-lg-1">
            <b-form-input
              type="text"
              :disabled="true"
              v-model="apartment.floor"
              :placeholder="$t('apartment.floor')"
            />
          </div>
        </div>

        <div class="form-group">
          <label class="col-sm-3 col-md-3 col-lg-3 control-label">{{
            $t("apartment.room")
          }}</label>
          <div class="col-sm-1 col-md-1 col-lg-1">
            <b-form-input
              type="text"
              :disabled="true"
              v-model="apartment.room"
              :placeholder="$t('apartment.room')"
            />
          </div>
        </div>

        <!-- END - Add new field -->

        <div class="form-group">
          <label class="col-sm-3 col-md-3 col-lg-3 control-label">{{
            $t("apartment.other_details")
          }}</label>
          <div class="col-sm-4 col-md-4 col-lg-4">
            <b-form-input
              type="text"
              v-model="apartment.other_details"
              :placeholder="$t('apartment.other_details')"
            />
          </div>
        </div>

        <!-- Customer name -->
        <!-- <div class="form-group" v-if="apartment.status !=1">
              <label class="col-sm-4 col-md-3 col-lg-3 control-label">{{$t('invoice.mainowner_fullname')}}</label>
              <div>
                <div class="col-sm-4 col-md-2 col-lg-2">
                  <input
                    v-model="customer_name"
                    type="text"
                    class="form-control"
                    :placeholder="$t('invoice.mainowner_fullname')"
                    :disabled="true"
                  >
                </div>
                <div class="col-sm-4 col-md-2 col-lg-2">
                  <input
                    v-model="identification_card"
                    type="text"
                    class="form-control"
                    :placeholder="$t('customer.identificationnumber')"
                    :disabled="true"
                  >
                </div>
            </div>
          </div>-->
      </div>
      <div class="box-footer">
        <button
          v-if="item === undefined"
          type="button"
          class="btn btn-labeled btn-danger"
          @click="onApartmentCancel"
          style="margin-right: 5px;background-color: #f29911;border-color: #f29911;"
        >
          <span class="btn-label"> <i class="fa fa-mail-reply"></i> </span>
          {{ $t("common.back") }}
        </button>
        <button
          v-if="item === undefined"
          type="button"
          class="btn btn-labeled btn-primary"
          @click="onOpenMeterDevices"
        >
          <span class="btn-label"> <i class="fa fa-tachometer"></i> </span>
          Thiết Bị Đo
        </button>
        <button
          v-if="
            (has_perm('update_apartment') && item === undefined) ||
              GET_ACCOUNT_DATA.id == 1
          "
          type="button"
          class="btn btn-labeled btn-success pull-right"
          @click="onApartmentSubmit"
          style="margin-right: 5px;"
        >
          <span class="btn-label">
            <i class="glyphicon glyphicon-ok"></i>
          </span>
          {{ $t("common.save") }}
        </button>
      </div>
    </form>

    <lte-core-alert
      v-for="snackbar in GET_SNACK_BAR"
      :key="snackbar.id"
      :item="snackbar"
    ></lte-core-alert>
    <router-view></router-view>
  </div>
</template>

<script>
import LTECoreAlert from "@/components/LTESnackBar.vue";
import { mapGetters, mapActions } from "vuex";
import utils from '@/lib/utils';

export default {
  name: "ApartmentAdd",
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      infoShow: false,
      apartmentStatusOptions: [
        { text: "Chưa Bàn Giao", value: 1 },
        { text: "Bàn Giao", value: 2 },
        { text: "Đã Ở", value: 3 }
      ],
      isExistTenant: false,
      pagetitle: "apartment.editaddnew[0]",
      apartment: {
        id: 0,
        apartment_code: "",
        size: "",
        status: 1,
        not_rent: true,
        bathroom_count: 0,
        bedroom_count: 0,
        room_count: 0,

        block: "",
        floor: 0,
        room: 0,
        other_details: ""
      },
      options: {
        format: "DD/MM/YYYY",
        useCurrent: false
      },
      customer_name: "",
      identification_card: ""
    };
  },

  watch: {
    APARTMENT_DETAIL_DATA: function() {
      this.apartment.apartment_code = this.APARTMENT_DETAIL_DATA.apartment_code;
      this.apartment.size = this.APARTMENT_DETAIL_DATA.size;
      this.apartment.status = this.APARTMENT_DETAIL_DATA.status;
      this.apartment.bathroom_count = this.APARTMENT_DETAIL_DATA.bathroom_count;
      this.apartment.bedroom_count = this.APARTMENT_DETAIL_DATA.bedroom_count;
      this.apartment.room_count = this.APARTMENT_DETAIL_DATA.room_count;
      this.apartment.not_rent = !this.APARTMENT_DETAIL_DATA.rent;

      this.apartment.block = this.APARTMENT_DETAIL_DATA.block;
      this.apartment.floor = this.APARTMENT_DETAIL_DATA.floor;
      this.apartment.room = this.APARTMENT_DETAIL_DATA.room;
      this.apartment.other_details = this.APARTMENT_DETAIL_DATA.other_details;

      // disable "Chưa Bàn Giao" option
      if (this.apartment.status >= 2) {
        this.apartmentStatusOptions = [
          { text: "Chưa Bàn Giao", value: 1, disabled: true },
          { text: "Bàn Giao", value: 2 },
          { text: "Đã Ở", value: 3 }
        ];
      }
    },
    //Get resident data and check exist or not exist tenant
    GET_RESIDENT_DATA: function() {
      for (let i = 0, size = this.GET_RESIDENT_DATA.length; i < size; i++) {
        let resident = this.GET_RESIDENT_DATA[i];
        if (resident.isTenant == true || resident.isTenant == "Yes") {
          this.isExistTenant = true;
        } else {
          this.isExistTenant = false;
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "APARTMENT_DETAIL_DATA",
      "GET_RESIDENT_DATA",
      "GET_ACCOUNT_DATA"
    ])
  },

  methods: {
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "ADD_APARTMENT",
      "UPDATE_APARTMENT",
      "GET_APARTMENT_DETAIL",
      "ON_SHOW_TOAST",
      "GET_RESIDENT_LIST"
    ]),
    onOpenMeterDevices: function() {
      if (!utils.isNull(this.$route.params.id)) {
        //  căn hộ chưa bàn giao => chốt điện & nước
        let apartment_id = this.$route.params.id;
        this.$router.push({
          name: "LeaseBackMeterDevices",
          params: {
            id: apartment_id
          }
        });
      }
    },
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    onClickRent: function() {
      this.apartment.not_rent = !this.apartment.not_rent;
    },
    onApartmentCancel: function() {
      this.$router.push({
        name: "LeaseBackApartmentList"
      });
    },
    validateData: function() {
      let validatedResult = "OK";
      let validation_keys = ["apartment_code", "size"];
      for (let key in this.apartment) {
        if (validation_keys.indexOf(key) < 0) {
          continue;
        }
        if (this.apartment[key] === null || this.apartment[key] === "") {
          validatedResult = `Thiếu ${key}`;
          break;
        } else {
          //
        }
      }
      return validatedResult;
    },
    onApartmentSubmit: function(event) {
      let result = this.validateData();
      if (result == "OK") {
        let data = {
          apartment_code: this.apartment.apartment_code,
          size: this.apartment.size,
          status: this.apartment.status,
          rent: !this.apartment.not_rent,
          bathroom_count: this.apartment.bathroom_count,
          bedroom_count: this.apartment.bedroom_count,
          room_count: this.apartment.room_count,

          block: this.apartment.block,
          floor: this.apartment.floor,
          room: this.apartment.room,
          other_details: this.apartment.other_details
        };

        if (parseInt(this.apartment.id) == 0) {
          // Add default mandatory services
          this.ADD_APARTMENT({ data: data }).then(
            function() {
              this.$router.push({ name: "LeaseBackApartmentList" });
              this.SUCCESS_TOAST();
            }.bind(this)
          )
          .catch(
            function() {
              this.ERROR_TOAST();
            }.bind(this)
          );
        } else {
          this.UPDATE_APARTMENT({ id: this.apartment.id, data: data }).then(
            function() {
              if (this.item === undefined) {
                this.$router.push({ name: "LeaseBackApartmentList" });
              } else {
                this.$emit("closeModal");
              }
              this.SUCCESS_TOAST();
            }.bind(this)
          )
          .catch(
            function() {
              this.ERROR_TOAST();
            }.bind(this)
          );
        }
      } else {
        this.ON_SHOW_TOAST({
          message: result,
          styleType: "danger"
        });
      }
    }
  },
  mounted() {
    let id = this.item !== undefined ? this.item.id : this.$route.params.id;
    if (parseInt(id) !== 0) {
      this.apartment.id = parseInt(id);
      this.pagetitle = "apartment.editaddnew[1]";
      this.infoShow = true;
      const data = {
        params: {
          apartment: this.apartment.id
        }
      };
      this.GET_RESIDENT_LIST(data).then(
        function() {
          if (parseInt(id) !== 0) {
            this.GET_APARTMENT_DETAIL({ id: id });
          }
        }.bind(this)
      );
    } else {
      //
    }
  },
  components: {
    "lte-core-alert": LTECoreAlert
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/Apartment/LeaseBackApartmentInputView.vue